export default "__VITE_ASSET__B7yL5kMb__"